import { Observer } from "mobx-react";
import { DocumentUploader, DocumentUploaderProps } from "src/components/uploader";
import { DocumentEditorDetailFragment } from "src/fragments/circularFragments.generated";
import { FieldState } from "src/utils/formState";

type BoundFileUploaderProps = Omit<DocumentUploaderProps, "file" | "onFinish" | "readonly" | "error"> & {
  field: FieldState<DocumentEditorDetailFragment | null | undefined>;
  readOnly?: boolean;
};

/** Wraps `DocumentUploader` and binds it to a form field */
export function BoundFileUploader(props: BoundFileUploaderProps) {
  const { field, readOnly, ...others } = props;
  return (
    <Observer>
      {() => (
        <DocumentUploader
          readOnly={readOnly ?? field.readOnly}
          file={field.value || undefined}
          onFinish={(file) => {
            field.set(file);
            field.blur();
          }}
          onClear={() => {
            field.set(undefined);
            field.blur();
          }}
          error={field.touched ? field.errors.join(" ") : undefined}
          {...others}
        />
      )}
    </Observer>
  );
}
